import axios from 'axios';
import React from 'react';
import { ACCESS_DENIED_EXCEPTION_TYPE, ELIGIBILITY_EXCEPTION_TYPE } from '../constants/constants';
import InternalServerError from './internal-server-error';


interface IErrorBoundaryProps {
  readonly children: JSX.Element | JSX.Element[];
}

interface IErrorBoundaryState {
  readonly error: any;
  readonly errorInfo: any;
  readonly hasError: boolean;
}
class ErrorBoundary extends React.Component<IErrorBoundaryProps, IErrorBoundaryState> {
  readonly state: IErrorBoundaryState = { error: undefined, errorInfo: undefined, hasError: false };

  componentDidCatch(error, errorInfo) {
    this.setState({
      error,
      errorInfo,
      hasError: true,
    });
  }
  componentDidMount() {
    axios.interceptors.request.use(req => {
      return req;
    });

    axios.interceptors.response.use(
      res => res,
        error => {
        if (!(error.response.status === 403 &&
          ( error.response.data.type.startWith(ELIGIBILITY_EXCEPTION_TYPE) 
          || error.response.data.type.startWith(ACCESS_DENIED_EXCEPTION_TYPE)) )) {
          this.setState({ error });
        }
        
      }  
    );
  }

  render() {
    const { error, errorInfo, hasError } = this.state;
    if (error || errorInfo) {
      const errorDetails =
        process.env.NODE_ENV === 'development' ? (
          <details className="preserve-space">
            {error && error.toString()}
            <br />
            {errorInfo?.componentStack}
          </details>
        ) : undefined;
      return (
        <div className="error-boundary">
          <InternalServerError error={error?.response?.data} />
          {errorDetails}
        </div>
      );

    }
    return this.props.children;
  }
}

export default ErrorBoundary;
/* @refresh reset */